import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CourseListMementoService } from './course-list-memento.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationInterceptorService {
  private readonly COURSE_CATALOG_ROUTES = ['/course-catalog', '/course-details', '/learning-path-details'];

  constructor(
    private router: Router,
    private courseMementoService: CourseListMementoService,
  ) {
    this.initializeNavigationInterceptor();
  }

  private initializeNavigationInterceptor(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.handleNavigation(event.url);
    });
  }

  private handleNavigation(url: string): void {
    const isCourseCatalogRoute = this.COURSE_CATALOG_ROUTES.some((route) => url.startsWith(route));

    if (!isCourseCatalogRoute) {
      if (this.courseMementoService.hasSavedState()) {
        this.courseMementoService.clearState();
      }
    }
  }
}
